export default interface Lore {
    name: string
    type: LoreType
}

export enum LoreType {
    ORGANIZATION = 'Organization'
}